






















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

@Component
export default class NumberPad extends Vue{
  @Prop(Number) readonly defaultAmount!: number;

  output = this.defaultAmount.toString();
  inputNumber(event: MouseEvent){ //event是鼠标事件
    const button = event.target as HTMLButtonElement; //否则event.target.textContent报错
    const input = button.textContent!;  // !表示不为空
    if (this.output.length === 16) { return; }
    if (this.output === '0') {
      if ('0123456789'.indexOf(input) >= 0) {
        this.output = input;
      } else {
        this.output += input;
      }
      return;
    }
    if (this.output.indexOf('.') >= 0 && input === '.') {return;}
    this.output += input;
  }
  remove() {
    if (this.output.length === 1) {
      this.output = '0';
    } else {
      this.output = this.output.slice(0, -1);
    }
  }
  clear() {
    this.output = '0';
  }
  finish(){
    if (this.output === '0'){
      window.alert('请输入支出或收入的具体金额 !');
    } else {
      this.$emit('update:defaultAmount', parseFloat(this.output));
      this.$emit('submit');
      this.output = '0';
      window.alert('您有一笔账单已被记录在册 !')
    }
  }
}
